<div class="contact-form">
    <h3 class="heading">Fill the form</h3>
    <span (click)="closeModal()" class="close-btn pointer">
        <!-- <img [src]='assets_url + "Live-Stream-assets/close-icon-white.svg"'> -->
        <app-svg [icon]="'close-icon-white1'"></app-svg>
    </span>
    <!-- <a role="button" ><i class="fa fa-times" aria-hidden="true"></i></a> -->
    <form [formGroup]="contactForm">
        <div fxLayout="row wrap" class="profile_basic" fxLayoutAlign="start center">
            <div fxFlex="100%" fxFlex.xs="100%" contactForm>
                <mat-form-field class="w-100">
                    <mat-label>First Name</mat-label>
                    <input class="fs-16" matInput placeholder="" contactForm formControlName="first_name" required>
                    <mat-error *ngIf="contactForm.get('first_name').hasError('required')">
                        Please enter first name
                    </mat-error>
                </mat-form-field>
            </div>
            <div fxFlex="100%" fxFlex.xs="100%" contactForm>
                <mat-form-field class="w-100">
                    <mat-label>Last Name</mat-label>
                    <input class="fs-16" matInput placeholder="" formControlName="last_name" contactForm required>
                    <mat-error *ngIf="contactForm.get('last_name').hasError('required')">
                        Please enter last name
                    </mat-error>
                </mat-form-field>
            </div>
            <div fxFlex="100%" fxFlex.xs="100%" contactForm>
                <mat-form-field class="w-100">
                    <mat-label>Email</mat-label>
                    <input matInput placeholder="" formControlName="email" required contactForm>
                    <mat-error *ngIf="contactForm.get('email').hasError('required')">
                        Please enter email
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('email').hasError('email') || contactForm.get('email').hasError('pattern')">
                        Please enter valid email
                    </mat-error>
                </mat-form-field>
            </div>
            <div fxFlex="100%" fxFlex.xs="100%" class="phone-number-placeholder" contactForm>
                <span class="placeholder-label">Phone Number
                    <span
                        [ngClass]="{'placeholder-label-required' : (contactForm.get('phone_number').hasError('required') && businessPhoneValue.touched) }">*</span>
                </span>
                <mat-form-field class="w-100">
                    <!-- <input matInput countryFlagPhone allowValues isInputType="phone" contactForm
                        formControlName="phone_number" required>
                    <mat-error *ngIf="contactForm.get('phone_number').hasError('required')">
                        Please enter phone number
                    </mat-error>
                    <mat-error *ngIf="!contactForm.get('phone_number').hasError('required') && 
            contactForm.get('phone_number').hasError('isInvalid')">
                        Please enter valid phone number
                    </mat-error> -->
                    <input matInput hidden="true" />
                            <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                                [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
                                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                [selectFirstCountry]="true" [selectedCountryISO]="selectedCountry" [maxLength]="15"
                                [phoneValidation]="true" [separateDialCode]="separateDialCode" name="phone"
                                formControlName="phone_number">
                            </ngx-intl-tel-input>
                            <mat-hint
                                *ngIf="contactForm.get('phone_number').hasError('required') && businessPhoneValue.touched">
                                Please enter phone number
                            </mat-hint>
                            <mat-hint
                                *ngIf="!contactForm.get('phone_number').hasError('required') && 
                            (businessPhoneValue.invalid || (businessPhoneValue.touched && businessPhoneValue.invalid))">
                                Please enter valid phone number
                            </mat-hint>
                </mat-form-field>
            </div>
            <div fxFlex="100%" fxFlex.xs="100%" contactForm>
                <mat-form-field class="w-100">
                    <mat-label>Organisation Name</mat-label>
                    <input class="fs-16" matInput placeholder="" formControlName="org_name" contactForm required>
                    <mat-error *ngIf="contactForm.get('org_name').hasError('required')">
                        Please enter Organisation Name
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="mt-30 text-center">
            <button mat-flat-button class="btn flat-primary-button secondary-bg-button" (click)="sendDetails()">Submit</button>
            <!-- <button mat-flat-button class="square-btn bgc-grey ml-20" (click)="closeForm()">Cancel</button> -->
        </div>
    </form>
</div>